import type { ValueOf } from '@src/shared/types/utilities';

export const DATE_RANGE_OPTION = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last 7 Days',
  NEXT_WEEK: 'Next Week',
  LAST_MONTH: 'Last Month',
  EXACT_DATE: 'Exact Date',
  BEFORE_DATE: 'Before Date',
  AFTER_DATE: 'After Date',
  DATE_RANGE: 'Date Range',
} as const;

export type DateRangeOption = ValueOf<typeof DATE_RANGE_OPTION>;
